export const TRIANGLE_OWNER = '0x7081d3fb56f71868ad55780582bc37bbc536e6d6';
export const TRIANGLE_AUTH_STORAGE_KEY = 'crohamcity.triangle.owner-authorization.v1';

export function runTriangleCloud(Moralis, name, params = {}) {
  // Owner signatures authorize these calls; an old Parse session must not block them.
  return Moralis.Cloud.run(name, params, { sessionToken: '' });
}

export function usableTriangleAuthorization(proof, account = '', now = Date.now()) {
  return !!proof && proof.ownerAddress === TRIANGLE_OWNER && typeof proof.message === 'string' &&
    proof.message.startsWith('CrohamCity full triangle controls\n') &&
    typeof proof.signature === 'string' && /^0x[0-9a-f]{130}$/i.test(proof.signature) &&
    Number.isSafeInteger(proof.expiresAt) && proof.expiresAt > now &&
    (!account || String(account).toLowerCase() === TRIANGLE_OWNER);
}

export function readTriangleAuthorization(storage, now = Date.now()) {
  try {
    const value = storage?.getItem(TRIANGLE_AUTH_STORAGE_KEY);
    if (!value || value.length > 4096) return null;
    const proof = JSON.parse(value);
    if (usableTriangleAuthorization(proof, '', now)) return proof;
    storage.removeItem(TRIANGLE_AUTH_STORAGE_KEY);
  } catch { /* An unavailable browser store must not prevent signing in. */ }
  return null;
}

export async function signTriangleAuthorization({ signer, getChallenge, now = Date.now }) {
  if (!signer?.getAddress || !signer?.signMessage) throw new Error('Connect the primary owner wallet before signing.');
  const address = String(await signer.getAddress()).toLowerCase();
  if (address !== TRIANGLE_OWNER) throw new Error('Select the primary owner wallet 0x7081...e6D6 in your wallet.');
  const challenge = await getChallenge();
  if (challenge?.ownerAddress !== address || typeof challenge.message !== 'string' ||
      !challenge.message.startsWith('CrohamCity full triangle controls\n') ||
      !Number.isSafeInteger(challenge.expiresAt) || challenge.expiresAt <= now()) {
    throw new Error('The triangle authorization challenge is invalid or expired.');
  }
  const signature = await signer.signMessage(challenge.message);
  const proof = { message: challenge.message, signature, ownerAddress: address, expiresAt: challenge.expiresAt };
  if (!usableTriangleAuthorization(proof, await signer.getAddress(), now())) {
    throw new Error('The authorization expired or the connected wallet changed. Sign again.');
  }
  return proof;
}
